import { lazy } from "react";
import { AppRoute } from "../../../types/common";

const QrCode = lazy(() => import("./QrCode"));

const OutputRoute: AppRoute[] = [
  {
    path: "/qrcodes/:merchantCode",
    component: <QrCode />,
    exact: true,
  },
  {
    path: "/qrcodes/:merchantCode",
    component: <QrCode />,
    exact: true,
  },
];

export default OutputRoute;
